import {noop} from '@benchling/js-utils';
import React from 'react';

import {assert} from 'Asserts';
import AddUnitOperationLinksModal from 'studies/typed/process-development/AddUnitOperationLinksModal';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import runModal from 'ui-library/runModal';

interface LinkToPreviousUnitOperationsButtonProps {
  studyId: string;
  procedureRunId: string;
  procedureRunName: string;
}

export default function LinkToPreviousUnitOperationsButton(
  props: LinkToPreviousUnitOperationsButtonProps
): JSX.Element {
  let onClickHandler: () => void = noop;
  assert(props.procedureRunId != null, 'Procedure Run is not selected');
  assert(props.procedureRunName != null, 'Procedure Run is not selected');
  onClickHandler = async () => {
    await runModal(AddUnitOperationLinksModal, {
      studyId: props.studyId,
      procedureRunId: props.procedureRunId,
      procedureRunName: props.procedureRunName,
    });
  };
  return (
    <Button
      buttonStyle={ButtonStyle.TERTIARY_GRAY}
      size={ButtonSize.MEDIUM}
      onClick={onClickHandler}
      text="Link to previous"
    />
  );
}
